<script>
import events from './events'
import { i18nRender } from '@/locales'
import themeColor from '@/components/SettingDrawer/themeColor'
import {getNoReadNum} from '@/api/system/notice.js';
import AnonymousLetterForm from '@/views/personnel/feedback/module/CreateForm.vue'

import bus from '@/utils/bus'
import {
	customerDetailPath,
	isSameCustomerDetailRoute,
	isSameTabRoute,
	cloneRoute,
	assignTabCacheKey,
	buildCustomerDetailFullPath,
	buildCustomerDetailTabKey,
	findTabPageIndex,
	syncTabPageSnapshot
} from '@/utils/routeTab'

export default {
	name: 'MultiTab',
	components: {
		AnonymousLetterForm
	},
	data() {
		return {
			pages: [],
			activeIndex: 0,
			routeChangeLock: false,
			background: localStorage.getItem('theme-color') || '#2c62c4',
			accountList:localStorage.getItem('ACCOUNT_LIST') ? JSON.parse(localStorage.getItem('ACCOUNT_LIST'))  : [],
			noRead:null
		}
	},
	mounted() {
		// 初始化主题色
		this.background = localStorage.getItem('theme-color') || '#2c62c4'
		// 监听主题色变化
		window.addEventListener('theme-color-changed', (e) => {
			this.background = e.detail.color
		})
	},
	created() {
		console.log(this.background)
		// bind event
		events.$on('open', val => {
			if (!val) {
				throw new Error(`multi-tab: open tab ${val} err`)
			}
			this.activeIndex = val
		}).$on('close', val => {
			if (!val) {
				this.closeThat(this.activeIndex)
				return
			}
			this.closeThat(val)
		}).$on('rename', ({ key, name }) => {
			try {
				const item = this.pages.find(item => item.fullPath === key
					|| item.cacheKey === key
					|| (item.path === customerDetailPath && buildCustomerDetailTabKey(item.query) === key)
					|| (item.path === customerDetailPath && buildCustomerDetailFullPath(item.query) === key))
				if (item) {
					if (!item.meta) {
						item.meta = {}
					}
					item.meta.customTitle = name
					this.$forceUpdate()
				}
			} catch (e) {
			}
		})
		bus.$on('closeTab', (routePath) => {
			this.closeExternalTab(routePath)
		})
		bus.$on('handleLook', () => {
			this.getNoRead();
		})
		this.pages.push(assignTabCacheKey(cloneRoute(this.$route)))
		this.syncPagesToStore()
		this.selectedLastPath()
		this.getNoRead();
		this.$nextTick(() => {
			this.bindTabWheelScroll()
			this.bindTabArrowScroll()
			this.initTabResizeObserver()
			this.updateArrowState()
		})
	},
	beforeDestroy() {
		if (this.tabResizeObserver) {
			this.tabResizeObserver.disconnect()
			this.tabResizeObserver = null
		}
		if (this._arrowStateTimer) {
			clearTimeout(this._arrowStateTimer)
			this._arrowStateTimer = null
		}
		if (this._pendingRouteFrame != null) {
			cancelAnimationFrame(this._pendingRouteFrame)
			this._pendingRouteFrame = null
		}
	},
	computed: {
		homePath() {
			return this.$store.getters.defaultRoutePath || this.$route.path
		}
	},
	methods: {
		syncPagesToStore() {
			const prevPages = this.$store.state.multiTab.pages || []
			const nextPages = this.pages || []
			// 仅在页签结构变化时写入，避免每次菜单切换都触发全量依赖重渲染
			const pagesChanged = prevPages.length !== nextPages.length ||
				nextPages.some((page, index) => {
					const prev = prevPages[index]
					return !prev ||
						prev.path !== page.path ||
						prev.cacheKey !== page.cacheKey ||
						prev.name !== page.name ||
						((prev.meta && prev.meta.customTitle) || '') !== ((page.meta && page.meta.customTitle) || '')
				})
			if (pagesChanged || prevPages !== nextPages) {
				this.$store.commit('multiTab/SET_PAGES', this.pages)
			}
			if (this.$store.state.multiTab.activeIndex !== this.activeIndex) {
				this.$store.commit('multiTab/SET_ACTIVE_INDEX', this.activeIndex)
			}
		},
		getNavOffset(nav) {
			if (!nav) {
				return 0
			}
			const transform = window.getComputedStyle(nav).transform
			if (!transform || transform === 'none') {
				return 0
			}
			const matrixMatch = transform.match(/matrix\(([^)]+)\)/)
			if (matrixMatch) {
				const values = matrixMatch[1].split(',').map(item => parseFloat(item.trim()))
				return values[4] || 0
			}
			const translateMatch = transform.match(/translate3d\(([^,]+)/)
			return translateMatch ? parseFloat(translateMatch[1]) : 0
		},
		setNavOffset(nav, offset) {
			if (!nav) {
				return
			}
			nav.style.transform = `translate3d(${offset}px, 0, 0)`
		},
		scheduleUpdateArrowState() {
			if (this._arrowStateTimer) {
				clearTimeout(this._arrowStateTimer)
			}
			this._arrowStateTimer = setTimeout(() => {
				this._arrowStateTimer = null
				this.updateArrowState()
			}, 50)
		},
		updateArrowState() {
			const root = this.$el
			if (!root) {
				return
			}
			const nav = root.querySelector('.ant-tabs-nav')
			const wrap = root.querySelector('.ant-tabs-nav-wrap')
			const prevBtn = root.querySelector('.ant-tabs-tab-prev')
			const nextBtn = root.querySelector('.ant-tabs-tab-next')
			if (!nav || !wrap || !prevBtn || !nextBtn) {
				return
			}
			const offset = this.getNavOffset(nav)
			const wrapWidth = wrap.offsetWidth
			const navWidth = nav.scrollWidth
			const needScroll = navWidth > wrapWidth + 1
			const maxOffset = Math.min(0, wrapWidth - navWidth)
			const canPrev = offset < -1
			const canNext = offset > maxOffset + 1

			prevBtn.classList.toggle('ant-tabs-tab-arrow-show', needScroll)
			nextBtn.classList.toggle('ant-tabs-tab-arrow-show', needScroll)
			prevBtn.classList.toggle('ant-tabs-tab-btn-disabled', !canPrev)
			nextBtn.classList.toggle('ant-tabs-tab-btn-disabled', !canNext)
		},
		initTabResizeObserver() {
			const container = this.$el && this.$el.querySelector('.ant-tabs-nav-container')
			if (!container || container._multiTabResizeObserved) {
				return
			}
			container._multiTabResizeObserved = true
			this.tabResizeObserver = new ResizeObserver(() => {
				this.scheduleUpdateArrowState()
			})
			this.tabResizeObserver.observe(container)
		},
		scrollTabsByStep(direction) {
			const nav = this.$el && this.$el.querySelector('.ant-tabs-nav')
			const wrap = this.$el && this.$el.querySelector('.ant-tabs-nav-wrap')
			if (!nav || !wrap) {
				return
			}
			const tabs = Array.from(nav.querySelectorAll('.ant-tabs-tab'))
			if (!tabs.length) {
				return
			}
			const currentOffset = this.getNavOffset(nav)
			const wrapWidth = wrap.offsetWidth
			const navWidth = nav.scrollWidth
			const maxOffset = Math.min(0, wrapWidth - navWidth)
			const viewportLeft = -currentOffset
			let firstVisibleIdx = 0
			for (let i = 0; i < tabs.length; i++) {
				if (tabs[i].offsetLeft + tabs[i].offsetWidth > viewportLeft + 1) {
					firstVisibleIdx = i
					break
				}
			}
			const targetIdx = direction > 0
				? Math.min(firstVisibleIdx + 1, tabs.length - 1)
				: Math.max(firstVisibleIdx - 1, 0)
			let newOffset = -tabs[targetIdx].offsetLeft
			newOffset = Math.max(maxOffset, Math.min(0, newOffset))
			this.setNavOffset(nav, newOffset)
			this.updateArrowState()
		},
		bindTabArrowScroll() {
			const root = this.$el
			if (!root || root._multiTabArrowDelegated) {
				return
			}
			root._multiTabArrowDelegated = true
			root.addEventListener('click', (e) => {
				const target = e.target.closest('.ant-tabs-tab-prev, .ant-tabs-tab-next')
				if (!target || !root.contains(target)) {
					return
				}
				if (target.classList.contains('ant-tabs-tab-btn-disabled')) {
					return
				}
				e.stopPropagation()
				e.preventDefault()
				this.scrollTabsByStep(target.classList.contains('ant-tabs-tab-prev') ? -1 : 1)
			}, true)
		},
		bindTabWheelScroll() {
			const wrap = this.$el && this.$el.querySelector('.ant-tabs-nav-wrap')
			if (!wrap || wrap._multiTabWheelBound) {
				return
			}
			wrap._multiTabWheelBound = true
			wrap.addEventListener('wheel', (e) => {
				if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) {
					return
				}
				const nav = this.$el && this.$el.querySelector('.ant-tabs-nav')
				if (!nav) {
					return
				}
				const wrapWidth = wrap.offsetWidth
				const maxOffset = Math.min(0, wrapWidth - nav.scrollWidth)
				let offset = this.getNavOffset(nav)
				offset = Math.max(maxOffset, Math.min(0, offset - e.deltaY))
				this.setNavOffset(nav, offset)
				this.updateArrowState()
				e.preventDefault()
			}, { passive: false })
		},
		scrollActiveTabIntoView() {
			const nav = this.$el && this.$el.querySelector('.ant-tabs-nav')
			const wrap = this.$el && this.$el.querySelector('.ant-tabs-nav-wrap')
			const activeTab = this.$el && this.$el.querySelector('.ant-tabs-tab-active')
			if (!nav || !wrap || !activeTab) {
				return
			}
			const currentOffset = this.getNavOffset(nav)
			const wrapWidth = wrap.offsetWidth
			const viewportLeft = -currentOffset
			const tabLeft = activeTab.offsetLeft
			const tabRight = tabLeft + activeTab.offsetWidth
			const maxOffset = Math.min(0, wrapWidth - nav.scrollWidth)
			if (tabLeft < viewportLeft) {
				this.setNavOffset(nav, Math.max(maxOffset, -tabLeft))
			} else if (tabRight > viewportLeft + wrapWidth) {
				this.setNavOffset(nav, Math.max(maxOffset, Math.min(0, -(tabRight - wrapWidth))))
			}
			this.scheduleUpdateArrowState()
		},
		navigateToTabPage(page) {
			if (!page || isSameTabRoute(this.$route, page)) {
				return
			}
			if (this._pendingRouteFrame != null) {
				cancelAnimationFrame(this._pendingRouteFrame)
			}
			// 先让标签高亮完成绘制，再推路由，减轻“点了要愣一下”的感觉
			this._pendingRouteFrame = requestAnimationFrame(() => {
				this._pendingRouteFrame = null
				this.$router.push({
					path: page.path,
					query: page.query,
					params: page.params
				}).catch(() => {})
			})
		},
		// 关闭标签
		closeExternalTab(routePath) {
		  const index = this.pages.findIndex(item => item.path === routePath)
		  if (index > 0 && this.pages.length > 1) {
		    this.remove(index)
		  }
		},
		// 切换账号
		async handlechangeAccount(e){
			console.log(e);
			let mobile = e.key;
			if(mobile=="logout"){
				return false
			}
			try {
				// 1. 切换账号（只传账号）
				await this.$store.dispatch('SwitchAccount', mobile)
				// 2. 重新获取新账号信息
				await this.$store.dispatch('GetInfo')
				// 3. 可选：刷新页面（不加也可以，看你需求）
				location.reload()
			} catch (e) {
				console.log('切换失败', e)
			}
		},
		async getNoRead(){
			await getNoReadNum().then(res => {
				console.log('未读消息',res);
				if(res.code=='20001'){
					this.noRead = res.data;
				}
			})
		},
		onEdit(targetKey, action) {
			this[action](targetKey)
		},
		remove(targetIndex) {
			const closedPage = this.pages[targetIndex]
			this.pages.splice(targetIndex, 1)
			// 判断当前标签是否关闭，若关闭则跳转到最后一个还存在的标签页
			if (this.activeIndex === targetIndex) {
				this.selectedLastPath()
			} else if (this.activeIndex > targetIndex) {
				this.activeIndex--
			}
			const stillOpen = this.pages.some(page => page.name && page.name === closedPage.name)
			if (!stillOpen && closedPage && closedPage.name) {
				this.$store.dispatch('tagsView/delCachedView', closedPage)
			}
			this.syncPagesToStore()
		},
		selectedLastPath() {
			this.activeIndex = this.pages.length - 1
			const page = this.pages[this.activeIndex]
			if (page.name) {
				this.$store.dispatch('tagsView/addCachedView', page)
			}
			this.$router.push({ path: page.path, query: page.query, params: page.params })
		},

		// content menu
		closeThat(e) {
			console.log('关闭当前',e)
			// 判断是否为最后一个标签页，如果是最后一个，则无法被关闭
			if (this.pages.length > 1) {
				this.remove(e)
			} else {
				this.$message.info('这是最后一个标签了, 无法被关闭')
			}
		},
		closeLeft(e) {
			if (e > 1) {
				for (let index = 1; index < e; index++) {
					this.remove(1)
				}
			} else {
				this.$message.info('左侧没有标签')
			}
		},
		closeRight(e) {
			if (e < (this.pages.length - 1)) {
				while (e < this.pages.length - 1) {
					this.remove(e + 1)
				}
			} else {
				this.$message.info('右侧没有标签')
			}
		},
		closeAll(e) {
			while (this.pages.length > 1) {
				this.remove(1)
			}
		},
		closeMenuClick(key, route) {
			this[key](route)
		},
		renderTabPaneMenu(e, index) {
			return (
				<a-menu {...{ on: { click: ({ key, item, domEvent }) => { this.closeMenuClick(key, index) } } }}>
					<a-menu-item disabled={index === 0} key="closeThat">关闭当前标签</a-menu-item>
					<a-menu-item disabled={this.pages.length === index + 1} key="closeRight">关闭右侧</a-menu-item>
					<a-menu-item disabled={index <= 1} key="closeLeft">关闭左侧</a-menu-item>
					<a-menu-item disabled={this.pages.length === 1} key="closeAll">关闭全部</a-menu-item>
				</a-menu>
			)
		},
		// render
		renderTabPane(title, keyPath, index) {
			const menu = this.renderTabPaneMenu(keyPath, index)

			return (
				<a-dropdown overlay={menu} trigger={['contextmenu']}>
					<span style={{ userSelect: 'none' }}>{i18nRender(title)} </span>
				</a-dropdown>
			)
		}
	},
	watch: {
		pages() {
			this.$nextTick(() => {
				this.scheduleUpdateArrowState()
			})
		},
		'$route': function (newVal) {
			const routeSnapshot = cloneRoute(newVal)
			let currentIndex = findTabPageIndex(this.pages, routeSnapshot)
			const navAction = this.$store.state.multiTab.navAction
			if (currentIndex < 0) {
				if (navAction === 'replace' && this.pages[this.activeIndex]) {
					// replace 时保留原 tab 的 cacheKey，避免 router-view :key 变化导致
					// keep-alive 不断堆积详情实例，挤掉列表页缓存（返回列表像“刷新”）
					const page = this.pages[this.activeIndex]
					const stableCacheKey = page.cacheKey
					syncTabPageSnapshot(page, routeSnapshot)
					if (stableCacheKey) {
						page.cacheKey = stableCacheKey
					}
					currentIndex = this.activeIndex
				} else {
					assignTabCacheKey(routeSnapshot)
					this.pages.push(routeSnapshot)
					currentIndex = this.pages.length - 1
				}
			} else {
				syncTabPageSnapshot(this.pages[currentIndex], routeSnapshot)
			}
			this.$store.commit('multiTab/CLEAR_NAV_ACTION')
			if (routeSnapshot.name) {
				this.$store.dispatch('tagsView/addCachedView', routeSnapshot)
			}
			this.routeChangeLock = true
			this.activeIndex = currentIndex
			this.syncPagesToStore()
			this.$nextTick(() => {
				this.routeChangeLock = false
				this.scrollActiveTabIntoView()
			})
		},
		activeIndex: function (index) {
			if (this.routeChangeLock) {
				return
			}
			const page = this.pages[index]
			if (!page) {
				return
			}
			if (page.name) {
				this.$store.dispatch('tagsView/addCachedView', page)
			}
			this.navigateToTabPage(page)
			this.$nextTick(() => {
				this.scrollActiveTabIntoView()
			})
		}
	},
	render() {
		const { onEdit, $data: { pages } } = this
		const panes = pages.map((page, index) => {
			return (
				<a-tab-pane
					style={{ height: 0 }}
					tab={this.renderTabPane(page.meta.customTitle || page.meta.title, page.path, index)}
					key={index} closable={page.path !== this.homePath}
				>
				</a-tab-pane>)
		})

		return (
			<div class="ant-pro-multi-tab" style="padding:-24px -24px 0 -24px;">
				<div class="ant-pro-multi-tab-wrapper">

					{/* 左侧标签页（过多时可横向滚动） */}
					<div class="ant-pro-multi-tab-tabs">
						<a-tabs
							hideAdd
							type={'editable-card'}
							v-model={this.activeIndex}
							tabBarStyle={{ background: this.background, margin: 0, paddingLeft: '16px', paddingTop: '1px' }}
							{...{ on: { edit: onEdit } }}>
							{panes}
						</a-tabs>
					</div>

					{/* 右侧：消息图标 + 退出登录按钮 */}
					<div class="ant-pro-multi-tab-actions">
						{/* 刷新页面 */}
						<a-icon type="redo" style={{
								fontSize: '16px',
								color: this.$store.getters.showHelpIcon ? '#FFD700' : '#fff',
								cursor: 'pointer'
							}}  onClick={() => {
								window.location.reload()
							}}/>
						{/* 添加匿名信 */}
						<a-tooltip title="添加匿名信">
							<a-icon
								type="message"
								style={{
									fontSize: '16px',
									color: '#fff',
									cursor: 'pointer'
								}}
								onClick={() => {
									if (this.$refs.AnonymousLetterForm) {
										this.$refs.AnonymousLetterForm.openModal()
									}
								}}
							/>
						</a-tooltip>
						{/* 消息图标 */}
						<a-badge count={this.noRead} overflowCount={99}>
							<a-icon
								type="bell"
								style="font-size: 16px; color: #fff; cursor: pointer;"
								onClick={() => {
									// 这里可以写跳转到消息页面
									// c/views/system/notice/index.vue
									this.$router.push('/system/notice/newList')
								}}
							/>
						</a-badge>
						
						<a-icon
							type="bulb"
							style={{
								fontSize: '16px',
								color: this.$store.getters.showHelpIcon ? '#FFD700' : '#fff',
								cursor: 'pointer'
							}}
							onClick={() => {
								this.$store.commit('SET_SHOW_HELP_ICON', !this.$store.getters.showHelpIcon)
							}}
						/>

						{/* 退出登录按钮 */}
						<a-button
							ghost
							size="small"
							style="margin-right:20px;"
							onClick={() => {
								this.$confirm({
									title: '提示',
									content: '确定要退出登录吗？',
									zIndex: 5000,
									onOk: () => {
										// 调用退出登录方法
										this.$ws.closeWebSocket();
										return this.$store.dispatch('Logout').then(() => {
											// ✅ 桌面端 + 网页端 通用跳转（关键修复）
											localStorage.removeItem('ACCOUNT_LIST');
											localStorage.removeItem('CLUEEDIT');
											// window.location.href = 'https://crmadmin.888jn.cn' 
											window.location.href = 'https://xwd.juneng.yun'
										})
									}
								})
							}}
						>
							退出登录
						</a-button>
					</div>
				</div>
				<AnonymousLetterForm ref="AnonymousLetterForm" />
			</div>
		)
	}
	
	// 随意切换登录方法
	// <a-dropdown style="margin-right:20px;">
	// 	<a-button ghost>退出/切换</a-button>
	// 	<a-menu slot="overlay" onClick={this.handlechangeAccount}>
	// 		{this.accountList.map((item, index) => (
	// 			<a-menu-item key={item.mobile}>{item.name}</a-menu-item>
	// 		))}
	// 		<a-menu-item key="logout">
	// 			<a class="margin-left" href="javascript:void(0)" onClick={() => {
	// 				this.$confirm({
	// 					title: '提示',
	// 					content: '确定要退出登录吗？',
	// 					onOk: () => {
	// 						// 调用退出登录方法
	// 						this.$ws.closeWebSocket();
	// 						return this.$store.dispatch('Logout').then(() => {
	// 							location.href = '/index'
	// 						})
	// 					}
	// 				})
	// 			}}>退出登录</a>
	// 		</a-menu-item>
	// 	</a-menu>
	// </a-dropdown>
	
	// render() {
	// 	const { onEdit, $data: { pages } } = this
	// 	const panes = pages.map((page, index) => {
	// 		return (
	// 			<a-tab-pane
	// 				style={{ height: 0 }}
	// 				tab={this.renderTabPane(page.meta.customTitle || page.meta.title, page.path, index)}
	// 				key={index} closable={page.path !== homeRoute.path}
	// 			>
	// 			</a-tab-pane>)
	// 	})

	// 	return (
	// 		<div class="ant-pro-multi-tab">
	// 			<div class="ant-pro-multi-tab-wrapper">
	// 				<a-tabs
	// 					hideAdd
	// 					type={'editable-card'}
	// 					v-model={this.activeIndex}
	// 					tabBarStyle={{ background: '#fff', margin: 0, paddingLeft: '16px', paddingTop: '1px' }}
	// 					{...{ on: { edit: onEdit } }}>
	// 					{panes}
	// 				</a-tabs>
	// 			</div>
	// 		</div>
	// 	)
	// }
}
</script>

<style lang="less" scoped>
.ant-pro-multi-tab {
	background: var(--theme-color, #2c62c4);
	margin: -24px -24px 0 -24px !important;
}

.ant-pro-multi-tab-wrapper {
	display: flex;
	align-items: center;
	overflow: hidden;
}

.ant-pro-multi-tab-tabs {
	flex: 1;
	min-width: 0;
	overflow: hidden;
}

.ant-pro-multi-tab-actions {
	flex-shrink: 0;
	padding-right: 16px;
	display: flex;
	align-items: center;
	gap: 12px;
}

.ant-badge {
	color: #fff;
}

// 修改tab关闭图标颜色
:deep(.ant-tabs-tab .ant-tabs-close-x) {
	color: #ffffff !important;
	font-size:15px;
}
// 鼠标悬浮 → 变红（优先级最高）
:deep(.ant-tabs-tab:hover .ant-tabs-close-x) {
	color: #ff4d4f !important;
}

.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
	background: var(--theme-color, #2c62c4) !important;
}

:deep(.ant-tabs-tab-remove) {
	color: #ffffff !important;
	font-weight: bold;
}

:deep(.ant-tabs-bar) {
	background: var(--theme-color, #1890ff) !important;
	// border-bottom: none !important;
}

:deep(.ant-tabs-tab) {
	background: var(--theme-color, #1890ff) !important;
	color: #ffffff !important;
	border: none !important;
	// margin: 0 4px !important;
	// padding: 8px 16px !important;
}

:deep(.ant-tabs-tab-active) {
	background: rgba(255, 255, 255, 0.5) !important;
	color: #ffffff !important;
	border-radius: 4px 4px 0 0 !important;
}

:deep(.ant-tabs-tab:hover) {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #ffffff !important;
}

:deep(.ant-tabs-tab-remove) {
	color: #ffffff !important;
}

:deep(.ant-tabs-tab[aria-selected="true"]) {
  background: rgba(255, 255, 255, 0.5) !important;
}

:deep(.ant-dropdown-trigger){
	font-size: 11px !important;
}


// :deep(.ant-tabs-nav-wrap){
// 	margin-top: 15px;
// }


// 修改tab  默认高度
:deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active){
	height:30px;
	line-height: 30px;
}

:deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab){
	height:30px;
	line-height: 30px;
	margin-top: 10px;
	padding: 0 10px !important;
}

// 加大tab 删除按钮大小
:deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab .ant-tabs-close-x){
	font-size:15px;
	font-weight: bold;
}

::v-deep .ant-tabs-tab:hover .ant-tabs-close-x {
  color: #ff4d4f !important;
}


// tab 标签过多时横向滚动（由 transform 控制，勿对 nav-wrap 设 overflow-x:auto）
:deep(.ant-tabs-nav-wrap) {
	overflow: hidden !important;
}

:deep(.ant-tabs-nav) {
	white-space: nowrap;
}

:deep(.ant-tabs-tab-prev:not(.ant-tabs-tab-btn-disabled)),
:deep(.ant-tabs-tab-next:not(.ant-tabs-tab-btn-disabled)) {
	cursor: pointer;
}

</style>